const E = {
  1: 'Select the gear icon to change and re-order the column display.',
  ExportToExcel: 'Creates an Excel file containing the data from all visible columns.',
  PageSize: 'Change to display 25, 50 or 100 results per page',
  Pagination: 'Navigate page listings by selecting a page number or going back or forth one page at a time using Back and Next.',
  DownloadPdf: 'Download a pdf copy of this summary page.',
  backToJobs: 'Choose Back to Jobs to take you back to the Jobs page.',
  backToOrders: 'Choose Back to Jobs to take you back to the Orders page.',
  pinnedOrders: 'Pinned items will have a coloured pin. You can find all your pinned items under the pinned tab of the landing page.',
};

const F = {
  1: 'Sélectionnez l\'icône représentant un engrenage pour modifier et réorganiser l\'affichage des colonnes.',
  ExportToExcel: 'Crée un fichier Excel contenant les données de toutes les colonnes visibles.',
  PageSize: 'Modifier pour afficher 25, 50 ou 100 résultats par page',
  Pagination: 'Naviguez dans les listes de pages en sélectionnant un numéro de page ou en parcourant les pages suivantes à l’aide des touches Précédent et Suivant.',
  DownloadPdf: 'Téléchargez une copie pdf de cette page de résumé.',
  backToOrders: 'Choisissez Retour aux tâches pour revenir à la page Commandes.',
  backToJobs: 'Choisissez Retour aux tâches pour revenir à la page des tâches.',
  pinnedOrders: 'Les articles épinglés auront une épingle de couleur. Vous pouvez trouver tous vos éléments épinglés sous l\'onglet épinglé de la page de destination.',
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/tutorials/common.js